import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { ModalResultFinalTeam } from '../../components/common/ModalResultFinalTeam';
import { audiosAssets } from '../../assets/audio';

export const SubtopicFinalTeam7 = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 final");
			ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded])
	return (
		<>
			<ModalResultFinalTeam
				title='¡Felicidades!'
				subTitle='¡Concluiste el Tema 7!'
				buttonText='Iniciar Tema 8'
				actionButton={() => {
					window.location.href = "/home8/tema8/introduction";
				}} actionBack={() => {
					window.location.href = "/home1";
				}}

			/>
		</>
	)
}


